import CardImageMarkers from "../../../../components/CockpitCards/CardImageMarkers";
import { liverpancreas } from "../../../../constants";


export default function LiverPancreasCard() {
  

return (

    <CardImageMarkers 
    
        image={liverpancreas}
        title="LIVER & PANCREAS HEALTH"
        subtitle="Reduce risk of diseases"
        markersTitle=""
        markers="GOT (AST), GPT (ALT), GGT,
                Bilirubin, ALP, Lipase
                Pancreatic Amylase, 
                Albumin
                "

    />


)
}